<template lang="html">
  <!-- Sidebar -->

  <nav id="sidebar" aria-label="Main Navigation">
    <!-- Side Header -->
    <div class="bg-header-dark">
      <div class="content-header bg-white-10">
        <!-- Logo -->
        <router-link class="link-fx font-w600 font-size-lg text-white" :to="{ path: '/' }" :exact="true">
          <span class="text-white-75">Sansiri</span><span class="text-white">API</span>
        </router-link>
        <!-- END Logo -->

        <!-- Options -->
        <div>
          <!-- Toggle Sidebar Style -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <!-- Class Toggle, functionality initialized in Helpers.coreToggleClass() -->
          <a class="js-class-toggle text-white-75" data-target="#sidebar-style-toggler"
             data-class="fa-toggle-off fa-toggle-on" data-toggle="layout" data-action="sidebar_style_toggle"
             href="javascript:void(0)">
            <i class="fa fa-toggle-off" id="sidebar-style-toggler"></i>
          </a>
          <!-- END Toggle Sidebar Style -->

          <!-- Close Sidebar, Visible only on mobile screens -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <a class="d-lg-none text-white ml-2" data-toggle="layout" data-action="sidebar_close"
             href="javascript:void(0)">
            <i class="fa fa-times-circle"></i>
          </a>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Options -->
      </div>
    </div>
    <!-- END Side Header -->

    <!-- Side Navigation -->
    <div class="content-side content-side-full">
      <ul class="nav-main">
        <!-- <li class="nav-main-heading">Base</li> -->
        <li v-for="link in links" class="nav-main-item" :key="link.name" :class="{ 'open': link.expand }">
          <a v-if="link.landing" class="nav-main-link" href="/search-cms" target="_blank">
            <i class="nav-main-link-icon si" :class="link.icon"></i>
            <span class="nav-main-link-name">{{ link.label }}</span>
          </a>
          <router-link v-if="!link.children && !link.landing" class="nav-main-link" :to="link.to">
            <i class="nav-main-link-icon si" :class="link.icon"></i>
            <span class="nav-main-link-name">{{ link.label }}</span>
            <span v-if="link.badge" class="nav-main-link-badge badge badge-pill badge-success">{{ link.badge }}</span>
          </router-link>
          <a v-if="link.children" class="nav-main-link nav-main-link-submenu" data-toggle="submenu" aria-haspopup="true"
             aria-expanded="false" href="#">
            <i class="nav-main-link-icon si" :class="link.icon"></i>
            <span class="nav-main-link-name">{{ link.label }}</span>
          </a>
          <ul v-for="sublink in link.children" v-if="link.children" :key="sublink.label" class="nav-main-submenu">
            <li class="nav-main-item">
              <router-link class="nav-main-link" :to="sublink.to">
                <span class="nav-main-link-name">{{ sublink.label }}</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- END Side Navigation -->
  </nav>
  <!-- END Sidebar -->
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          label: 'APIs',
          to: { path: '/api' },
          icon: 'si-settings'
        },
        {
          label: 'CRUD',
          to: { path: '/crud' },
          icon: 'si-pencil'
        },
        {
          label: 'Search API',
          to: { path: '/search-cms' },
          icon: 'si-magnifier',
          landing: true
        },
        {
          label: 'Tokens',
          to: { path: '/token' },
          icon: 'si-check'
        },
        // {
        //   label: 'Logs',
        //   to: { path: '/log' },
        //   icon: 'si-list'
        // },
        {
          label: 'Configulation',
          icon: 'si-wrench',
          children: [
            {
              label: 'Database',
              to: { path: '/database' },
              icon: 'si-pencil'
            },
            {
              label: 'Endpoint',
              to: { path: '/endpoint' },
              icon: 'si-pencil'
            },
            {
              label: 'API Group',
              to: { path: '/api-group' },
              icon: 'si-pencil'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    const route = this.$route
    if (route) {
      // this.isReady = true
      this.shouldExpandMatchItem(route)
    }
  },
  methods: {
    shouldExpandMatchItem(route) {
      // let matched = route.matched
      // let lastMatched = matched[matched.length - 1]
      this.links.forEach((item, index) => {
        if (item.to && item.to === route.path) {
          const item = this.links[index]
          item.expand = true
          this.$set(this.links, index, item)
        }
        if (item.children) {
          item.children.forEach((childItem, cIndex) => {
            const regex = /^\/([a-zA-Z0-9]*)/g
            const regex2 = /^\/([a-zA-Z0-9]*)/g
            if (typeof childItem.to.path === 'string') {
              const itemMatch = regex.exec(childItem.to.path)
              const routeMatch = regex2.exec(route.path)
              if (itemMatch && routeMatch && itemMatch[1] === routeMatch[1]) {
                const item = this.links[index]
                item.expand = true
                this.$set(this.links, index, item)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.nav-main-submenu .nav-main-link.router-link-exact-active {
  color: #000;
  background-color: transparent;
}

.nav-main-link.router-link-exact-active {
  color: #000;
  background-color: #e1effe;
}
</style>
